import { render, staticRenderFns } from "./TopicsIndependentIndex.vue?vue&type=template&id=500a12a8"
import script from "./TopicsIndependentIndex.vue?vue&type=script&lang=js"
export * from "./TopicsIndependentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports